module.exports = __webpack_public_path__ + "static/img/checkMark.9b87f43.png";